import {
  useOptimizationState,
  useOptimizationWorkflow,
} from 'components/common-form/sidePanel/advisory/basket-optimizer/hooks';
import { ProgressionBar } from 'components/shared/ProgressionBar/ProgressionBar';

type Props = {
  tabId: string;
};
export function BasketOptimizerProgressionBar({ tabId }: Props) {
  const { isOptimizing, estimatedComputationTimeInSeconds, optimizationStartDate } = useOptimizationState(tabId);
  const { onOptimizeCancelled } = useOptimizationWorkflow(tabId);
  return (
    isOptimizing &&
    optimizationStartDate &&
    estimatedComputationTimeInSeconds &&
    estimatedComputationTimeInSeconds !== 0 && (
      <div className="mt-2">
        <ProgressionBar
          className="bg-info"
          durationInMilliseconds={estimatedComputationTimeInSeconds * 1000}
          text=""
          startDate={optimizationStartDate}
          onCancel={onOptimizeCancelled}
          size="medium"
        />
      </div>
    )
  );
}
